import React from 'react';

const SellerDashboard = () => {
  const insights = [
    { label: 'Unpaid Amount', value: '₹12,500' },
    { label: 'Total Orders', value: '345' },
    { label: 'Processed Shipment', value: '310' },
    { label: 'Return Orders', value: '12' },
    { label: 'Canceled Orders', value: '23' },
    { label: 'Total Visitors Today', value: '1,204' },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Seller Dashboard</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li className="breadcrumb-item active">Overview</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Insight Cards */}
        <div className="row">
          {insights.map((item, index) => (
            <div className="col-md-4 mb-3" key={index}>
              <div className="card text-center shadow">
                <div className="card-body">
                  <h5 className="card-title fw-bold">{item.label}</h5>
                  <h4 className="text-primary">{item.value}</h4>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Charts */}
        <div className="row mt-4">
          <div className="col-md-6">
            <div className="card shadow">
              <div className="card-header">Daily Visitors</div>
              <div className="card-body">
                <div id="visitorsChart">[Visitor Chart]</div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card shadow">
              <div className="card-header">Page Views</div>
              <div className="card-body">
                <div id="pageViewsChart">[Page View Chart]</div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer mt-4 text-center">
          <div className="container-fluid">© 2025 Seller Portal</div>
        </footer>
      </div>
    </div>
  );
};

export default SellerDashboard;
